
        var result = require("!!../../../node_modules/css-loader/index.js!./page-subheader-bar.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/pages/page-subheader-bar.component.css
// module id = 2153
// module chunks = 1